import { useAccountScope } from '../context/AccountScope';
import isMobileLayout from '../utils/isMobileLayout';
import { useEffect, useState } from 'react';

function CreateUserModal({
  abierto,
  setAbierto
}) {
  const { fetch, account: scopeAccount, refreshAccountScope } = useAccountScope();
  const [isMobile, setIsMobile] = useState(() => isMobileLayout());
  useEffect(() => {
    const check = () => setIsMobile(isMobileLayout());
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);
  const [companies, setCompanies] = useState([]);
  const [companyId, setCompanyId] = useState('');
  const [users, setUsers] = useState([]);
  const [parentUserId, setParentUserId] = useState('');

  const [companyName, setCompanyName] = useState('');
  const [nit, setNit] = useState('');
  const [companyEmail, setCompanyEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // El JWT de MACCEZ contiene el ID; el rol se guarda con la sesión.
  const currentUser = scopeAccount;
  const currentRole = currentUser.role;
  const currentCompanyId = currentUser.company_id;

  const rolesPermitidosPorRol = {
    super_admin: [
      'admin_empresa',
      'administrador',
      'usuario'
    ],
    admin_empresa: [
      'administrador',
      'usuario'
    ],
    administrador: [
      'usuario'
    ],
    usuario: []
  };

  const rolesPermitidos =
    rolesPermitidosPorRol[currentRole] || [];

  const [role, setRole] = useState('');

  const puedeCrearEmpresa =
    currentRole === 'super_admin';

  const [modoCreacion, setModoCreacion] =
    useState(
      puedeCrearEmpresa
        ? 'empresa_nueva'
        : 'usuario'
    );

  const parentRoleToSelect =
    role === 'administrador' &&
    currentRole === 'super_admin'
      ? 'admin_empresa'
      : role === 'usuario' &&
        (
          currentRole === 'super_admin' ||
          currentRole === 'admin_empresa'
        )
        ? 'administrador'
        : null;

  const targetCompanyId =
    currentRole === 'super_admin'
      ? companyId
      : currentCompanyId;

  const availableParents =
    users.filter((user) =>
      user.role === parentRoleToSelect &&
      user.status === 'active' &&
      String(user.company_id) ===
        String(targetCompanyId)
    );

  useEffect(() => {
    if (!abierto) return;

    if (currentRole === 'super_admin') {
      cargarEmpresas();
    }

    if (
      currentRole === 'super_admin' ||
      currentRole === 'admin_empresa'
    ) {
      cargarUsuarios();
    }
  }, [abierto]);

  useEffect(() => {
    if (!abierto) return;

    setParentUserId('');

    if (modoCreacion === 'empresa_nueva') {
      setRole('admin_empresa');
      return;
    }

    setRole(rolesPermitidos[0] || '');
  }, [abierto, modoCreacion, currentRole]);

  if (!abierto) return null;

  async function cargarUsuarios() {
    try {
      const token = localStorage.getItem('token');

      const response = await fetch('/api/users', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (!response.ok) {
        setUsers([]);
        return;
      }

      const data = await response.json();
      setUsers(Array.isArray(data) ? data : []);
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error(
        'Error cargando responsables:',
        error
      );
      setUsers([]);
    }
  }

  async function cargarEmpresas() {
    try {
      const token = localStorage.getItem('token');

      const response = await fetch(
        '/api/companies',
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const data = await response.json();

      if (Array.isArray(data)) {
        setCompanies(data);
      }
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error(error);
    }
  }

  async function crearEmpresaConAdmin() {
    try {
      if (
        !companyName ||
        !nit ||
        !name ||
        !email ||
        !password
      ) {
        alert('Completa los campos obligatorios');
        return;
      }

      const token = localStorage.getItem('token');

      const response = await fetch(
        '/api/companies/create-client',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            company_name: companyName,
            nit,
            company_email: companyEmail,
            phone,
            address,
            admin_name: name,
            admin_email: email,
            admin_password: password
          })
        }
      );

      const data = await response.json();

      if (!response.ok) {
        alert(data.error || 'Error creando empresa');
        return;
      }

      alert(
        'Empresa y Admin Empresa creados correctamente'
      );
      setAbierto(false);
      refreshAccountScope();
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error(error);
      alert('Error de conexión');
    }
  }

  async function crearUsuario() {
    try {
      if (
        !name ||
        !email ||
        !password ||
        !role
      ) {
        alert('Completa los campos obligatorios');
        return;
      }

      if (
        currentRole === 'super_admin' &&
        !companyId
      ) {
        alert('Selecciona una empresa');
        return;
      }

      if (
        parentRoleToSelect &&
        !parentUserId
      ) {
        alert('Selecciona el responsable directo');
        return;
      }

      const token = localStorage.getItem('token');

      const response = await fetch(
        '/api/users',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            name,
            email,
            password,
            role,
            parent_user_id:
              parentRoleToSelect
                ? Number(parentUserId)
                : null,
            company_id:
              currentRole === 'super_admin'
                ? Number(companyId)
                : currentCompanyId
          })
        }
      );

      const data = await response.json();

      if (!response.ok) {
        alert(
          data.error ||
          'Error creando usuario'
        );
        return;
      }

      alert('Usuario creado correctamente');
      setAbierto(false);
      refreshAccountScope();
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error(error);
      alert('Error de conexión');
    }
  }

  function ejecutarCreacion() {
    if (modoCreacion === 'empresa_nueva') {
      crearEmpresaConAdmin();
      return;
    }

    crearUsuario();
  }

  return (
    <div style={overlayStyle}>
      <div style={{ ...modalStyle, ...(isMobile ? { width: 'calc(100vw - 24px)',
        maxHeight: 'calc(100dvh - 40px)', overflowY: 'auto',
        padding: 16, boxSizing: 'border-box' } : {}) }}>
        <Header setAbierto={setAbierto} />

        {rolesPermitidos.length === 0 && (
          <>
            <div style={warningStyle}>
              Tu rol actual no tiene permisos
              para crear usuarios.
            </div>

            <div style={footerStyle}>
              <button
                onClick={() => setAbierto(false)}
              >
                Cerrar
              </button>
            </div>
          </>
        )}

        {rolesPermitidos.length > 0 && (
          <>
            {puedeCrearEmpresa && (
              <>
                <SectionTitle>
                  Tipo de creación
                </SectionTitle>

                <select
                  value={modoCreacion}
                  onChange={(e) => {
                    setModoCreacion(e.target.value);
                    setParentUserId('');
                  }}
                  style={inputStyle}
                >
                  <option value="empresa_nueva">
                    Empresa nueva + Admin Empresa
                  </option>

          <option value="usuario">
  Cuenta para empresa existente
</option>
                </select>
              </>
            )}

            {modoCreacion === 'empresa_nueva' && (
              <>
                <SectionTitle>
                  Datos de la Empresa
                </SectionTitle>

                <div style={{ ...gridStyle, ...(isMobile ? { gridTemplateColumns: 'minmax(0, 1fr)' } : {}) }}>
                  <input
                    placeholder="Nombre empresa *"
                    value={companyName}
                    onChange={(e) =>
                      setCompanyName(e.target.value)
                    }
                    style={inputStyle}
                  />

                  <input
                    placeholder="NIT *"
                    value={nit}
                    onChange={(e) =>
                      setNit(e.target.value)
                    }
                    style={inputStyle}
                  />

                  <input
                    placeholder="Email empresa"
                    value={companyEmail}
                    onChange={(e) =>
                      setCompanyEmail(e.target.value)
                    }
                    style={inputStyle}
                  />

                  <input
                    placeholder="Teléfono"
                    value={phone}
                    onChange={(e) =>
                      setPhone(e.target.value)
                    }
                    style={inputStyle}
                  />

                  <input
                    placeholder="Dirección"
                    value={address}
                    onChange={(e) =>
                      setAddress(e.target.value)
                    }
                    style={{
                      ...inputStyle,
                      gridColumn: '1 / span 2'
                    }}
                  />
                </div>
              </>
            )}

            {modoCreacion === 'usuario' &&
              currentRole === 'super_admin' && (
                <>
                  <SectionTitle>
                    Empresa
                  </SectionTitle>

                  <select
                    value={companyId}
                    onChange={(e) => {
                      setCompanyId(e.target.value);
                      setParentUserId('');
                    }}
                    style={inputStyle}
                  >
                    <option value="">
                      Seleccionar empresa
                    </option>

                    {companies.map((company) => (
                      <option
                        key={company.id}
                        value={company.id}
                      >
                        {company.name}
                      </option>
                    ))}
                  </select>
                </>
              )}

            <SectionTitle>
              Datos del Usuario
            </SectionTitle>

            <div style={{ ...gridStyle, ...(isMobile ? { gridTemplateColumns: 'minmax(0, 1fr)' } : {}) }}>
              <input
                placeholder="Nombre completo *"
                value={name}
                onChange={(e) =>
                  setName(e.target.value)
                }
                style={inputStyle}
              />

              <input
                placeholder="Correo *"
                value={email}
                onChange={(e) =>
                  setEmail(e.target.value)
                }
                style={inputStyle}
              />

              <input
                placeholder="Contraseña temporal *"
                type="password"
                value={password}
                onChange={(e) =>
                  setPassword(e.target.value)
                }
                style={inputStyle}
              />

            <div>
  <label
    style={{
      display: 'block',
      marginBottom: 8,
      color: '#334155',
      fontWeight: 700
    }}
  >
    Rol de la cuenta
  </label>

  <select
    value={role}
    onChange={(e) => {
      setRole(e.target.value);
      setParentUserId('');
    }}
    style={inputStyle}
    disabled={modoCreacion === 'empresa_nueva'}
  >
    {modoCreacion === 'empresa_nueva' && (
      <option value="admin_empresa">
        Admin Empresa
      </option>
    )}

    {modoCreacion === 'usuario' &&
      rolesPermitidos.map((rol) => (
        <option key={rol} value={rol}>
          {formatRole(rol)}
        </option>
      ))}
  </select>
</div>

              {modoCreacion === 'usuario' &&
                parentRoleToSelect && (
                  <div
                    style={{
                      gridColumn: '1 / -1'
                    }}
                  >
                    <label
                      style={{
                        display: 'block',
                        marginBottom: 8
                      }}
                    >
                      {parentRoleToSelect ===
                      'admin_empresa'
                        ? 'Admin Empresa responsable'
                        : 'Administrador responsable'}
                    </label>

                    <select
                      value={parentUserId}
                      onChange={(e) =>
                        setParentUserId(
                          e.target.value
                        )
                      }
                      style={inputStyle}
                    >
                      <option value="">
                        Seleccionar responsable
                      </option>

                      {availableParents.map(
                        (user) => (
                          <option
                            key={user.id}
                            value={user.id}
                          >
                            {user.name} - {user.email}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                )}
            </div>

            <div style={footerStyle}>
              <button
                onClick={() => setAbierto(false)}
              >
                Cancelar
              </button>

              <button
                onClick={ejecutarCreacion}
                style={primaryButtonStyle}
              >
                {modoCreacion === 'empresa_nueva'
                  ? 'Crear Empresa'
                  : 'Crear Usuario'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

function formatRole(role) {
  const labels = {
    super_admin: 'Super Admin',
    admin_empresa: 'Admin Empresa',
    administrador: 'Administrador',
    usuario: 'Usuario'
  };

  return labels[role] || role;
}

function Header({ setAbierto }) {
  return (
    <div style={headerStyle}>
      <div>
        <h2 style={{ margin: 0 }}>
          Crear
        </h2>

        <p
          style={{
            marginTop: 6,
            color: '#64748b'
          }}
        >
          Gestión jerárquica de empresas
          y usuarios MACCEZ TRACK
        </p>
      </div>

      <button
        onClick={() => setAbierto(false)}
        style={{
          border: 'none',
          background: 'transparent',
          fontSize: 22,
          cursor: 'pointer'
        }}
      >
        ✕
      </button>
    </div>
  );
}

function SectionTitle({ children }) {
  return (
    <h3
      style={{
        marginTop: 24,
        marginBottom: 14,
        color: '#0f172a',
        fontSize: 18
      }}
    >
      {children}
    </h3>
  );
}

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(15,23,42,0.45)',
  backdropFilter: 'blur(4px)',
  zIndex: 99999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const modalStyle = {
  width: '760px',
  maxHeight: '90vh',
  overflowY: 'auto',
  background: '#fff',
  borderRadius: '24px',
  padding: '32px',
  boxShadow: '0 25px 50px rgba(0,0,0,0.15)'
};

const headerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '25px'
};

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '16px'
};

const inputStyle = {
  width: '100%',
  padding: '14px',
  border: '1px solid #cbd5e1',
  borderRadius: '12px',
  fontSize: '14px',
  outline: 'none'
};

const footerStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '12px',
  marginTop: '30px'
};

const primaryButtonStyle = {
  padding: '12px 20px',
  borderRadius: '12px',
  border: 'none',
  background: '#2563eb',
  color: '#fff',
  fontWeight: '700',
  cursor: 'pointer'
};

const warningStyle = {
  padding: '16px',
  background: '#fee2e2',
  color: '#991b1b',
  borderRadius: '12px',
  marginTop: '16px',
  fontWeight: '600'
};

export default CreateUserModal;
